import * as React from "react";
const UploadTipGradient = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={133}
    height={96}
    style={{marginLeft: "-10px"}}
    viewBox="0 0 133 96"
    fill="none"
    {...props}
  >
      <g>
    <path
      d="M97.6525 59.7757V96H8.69995C3.9061 95.4159 0.3551 91.9026 0 87.0349V12.8508C-7.90938e-05 4.47831 2.66333 0.584127 8.8775 0H97.6525V36.6053C99.428 41.0836 103.157 42.4466 106.885 38.9418C112.034 31.7376 121.267 29.9852 127.126 35.437C133.34 38.9418 135.826 53.7397 128.546 59.7757C121.267 66.5905 114.165 66.0063 105.465 56.0762C102.801 54.1291 98.8953 55.2974 97.6525 59.7757Z"
      fill="url(#paint0_linear_2040_1440)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2040_1440"
        x1={133}
        y1={11.5097}
        x2={-11.0645}
        y2={67.4397}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41B0F8" />
        <stop offset={0.505208} stopColor="#626DFD" />
        <stop offset={1} stopColor="#7232FB" />
      </linearGradient>
    </defs>
    <text x="30" y="60" fontFamily="Poppins" fontSize="32" fill="#fff">{props.number}</text>
  </g>
  </svg>
);
export default UploadTipGradient;
